import request from './axios'
//上传图片
export function tabPicture(data) {
  return request({
    url: '/lx/api/document/filesource/uploadWord',
    method: 'post',
    data
  })
}
// 删除
export function tabDelete(id) {
  return request({
    url: `/lx/api/document/filesource/removeById?id=${id}`,
    method: 'post'
  })
}
